"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = require("util");
var POINTS = 'pt';
// This is mapping table from browser size (1-7) to PT
exports.FONTSIZE_MAPPING = [
    8 /*1*/,
    10 /*2*/,
    12 /*3*/,
    14 /*4*/,
    18 /*5*/,
    24 /*6*/,
    36 /*7*/,
];
exports.FONT_SIZES = [8, 9, 10, 11, 12, 14, 16, 18, 20, 22, 24, 26, 28, 36, 48, 72];
// This list is used to populate font size picker drop down
exports.FONT_SIZE_LIST = exports.FONT_SIZES.map(function (size) { return size.toString(); });
function getFontSizeFromSizeOrIndex(sizeOrIndex) {
    return util_1.isNumber(sizeOrIndex) && sizeOrIndex <= 7
        ? exports.FONTSIZE_MAPPING[sizeOrIndex - 1]
        : sizeOrIndex;
}
exports.getFontSizeFromSizeOrIndex = getFontSizeFromSizeOrIndex;
function getFontSizeInPoints(size) {
    var result = getFontSizeFromSizeOrIndex(size).toString();
    return result ? result + POINTS : result;
}
exports.getFontSizeInPoints = getFontSizeInPoints;
//# sourceMappingURL=FontSize.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-format-options/lib/utils/FontSize.js
// module id = 2190
// module chunks = 2 3 59 108